import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import withPermissionProtection from 'hoc/withPermissionProtection';

import Grid from '@material-ui/core/Grid';
import Modal from 'components/CncUI/Modal';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import Link from 'components/CncUI/Link';

import useAuthentication from 'hooks/useAuthentication';
import useMutation from 'hooks/useMutation';

import cncLogo from 'images/CNCCAPSSIDEBYSIDELOGO.png';

const useStyles = makeStyles(({ palette }) => ({
  logoImageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.cncUI.default.primary,
    padding: '16px 0px',
  },
  paddedTop: {
    paddingTop: '16px',
  },
}));

const TermsAndConditionsDialog = () => {
  const classes = useStyles();
  const { refresh, logout } = useAuthentication();
  const mutate = useMutation('AcceptTermsAndConditions');
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      open
      id={'TermsAndConditions'}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      PaperProps={{ style: { margin: 0 } }}
    >
      <Modal.Content>
        <div className={classes.logoImageHeader}>
          <img alt="logo" align="center" src={cncLogo} width="300px" />
        </div>
        <Typography variant="h5" align="center" className={classes.paddedTop}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" size="long" className={classes.paddedTop}>
          I have read and agree to the Cast & Crew{' '}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            key="termsAndConditions-a"
            href="https://www.castandcrew.com/terms-of-use/"
          >
            Terms of Use
          </Link>{' '}
          and{' '}
          <Link
            href="https://www.castandcrew.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            key="termsAndConditions-privacy"
          >
            Privacy Policy
          </Link>
          . I consent to transacting electronically with Cast & Crew and using
          my electronic signature to sign and submit documents.
        </Typography>
      </Modal.Content>
      <Modal.Actions>
        <Grid container spacing={2} justify="flex-end">
          <Grid item>
            <Button
              secondary
              id={'TermsAndConditions-RejectButton'}
              disabled={loading}
              onClick={() => {
                setLoading(true);
                logout();
              }}
            >
              Decline
            </Button>
          </Grid>
          <Grid item>
            <Button
              id={'TermsAndConditions-AcceptButton'}
              loading={loading}
              onClick={() => {
                setLoading(true);
                mutate().then(() => refresh());
              }}
            >
              Accept
            </Button>
          </Grid>
        </Grid>
      </Modal.Actions>
    </Modal>
  );
};

export default withPermissionProtection('openid')(TermsAndConditionsDialog);
